export const accessLogSection = "/access-log/";

export const accessLogUrl = () => accessLogSection;
